module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('strong', [_vm._v("Ancient Thera, Modern Teacher")])]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("The wind working its")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("way through ancient")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("cracks and ill-fitting doors pestered")]), _vm._v(" "), _c('p', {
    staticClass: "txt4"
  }, [_vm._v("me all night.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Now it is morning and")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("nothing has settled down the")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("wind refuses to clear a space")]), _vm._v(" "), _c('p', {
    staticClass: "txt4"
  }, [_vm._v("for contemplation. This is stormy")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("country, lost to fire and sea, buried by meters and")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("meters of hard pumice rain and heavy boulders,")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("the volcano falling into its")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("fiery heart and sea blazing in to fill the steaming")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("crater that once was island.")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("Gorgeous culture ended here.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Island home to painters who knew")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("no restraint who took ceremonial rooms and")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("made them come alive with color and")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("form bound by no convention")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("strong joyful brush strokes bringing")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("life to barren walls on barren")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("land their homes painted still today")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("reminding us of times when")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("dolphins danced with fleets and")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("swallows swept the wild sea air")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("with song. Even now when")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("it all collapsed and 3500 years of")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("grief and dust had to be gently cleansed")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("to see their life even now Minoan joy")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("is here and even now their happy")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("life lifts my human heart above")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("my own ruined time and")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("reminds me that life can be")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("good even when lived in the shadow of")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("what must destroy it.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("They knew what was coming.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Many times tremors and ash")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("warned them to take their")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("treasures and flee yet they")]), _vm._v(" "), _c('p', {
    staticClass: "txt4"
  }, [_vm._v("returned to clean and")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("rebuild and recreate the life they loved")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("and then the volcano would")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("have no more of them and")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("Earth erupted with the violence")]), _vm._v(" "), _c('p', {
    staticClass: "txt4"
  }, [_vm._v("only found deep inside")]), _vm._v(" "), _c('p', {
    staticClass: "txt5"
  }, [_vm._v("creation. All fire the")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("blast blew black obsidian boulders like dust,")]), _vm._v(" "), _c('p', {
    staticClass: "txt2"
  }, [_vm._v("mythic energy reminding humans")]), _vm._v(" "), _c('p', {
    staticClass: "txt3"
  }, [_vm._v("how tenderly to walk")]), _vm._v(" "), _c('p', {
    staticClass: "txt4"
  }, [_vm._v("the earth that goes from beloved")]), _vm._v(" "), _c('p', {
    staticClass: "txt5"
  }, [_vm._v("to fire when it tolerates us")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("no longer.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Thera, Greece, May 2004")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f7044d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 84
// module chunks = 0